import React from 'react';
import Typography, { TypographyProps } from 'src/app/atoms/Typography/Typography';
import Attribution, { AttributionProps } from '../Attribution/Attribution';
import { QuoteContainer } from './QuoteAndAttribution.styles';

interface QuoteAndAttributionProps {
  quote: TypographyProps;
  subQuote?: TypographyProps;
  attribution: AttributionProps;
  textAlignSm?: 'left' | 'center';
}

const QuoteAndAttribution = ({
  quote,
  subQuote,
  attribution,
  textAlignSm = 'center',
}: QuoteAndAttributionProps): JSX.Element => {
  return (
    <QuoteContainer
      direction='column'
      gap='spacing-4xl'
      gapSm='spacing-5xl'
      maxWidth='width-2xl'
      padding={['spacing-none', 'spacing-3xl']}
      className={`quote-container sm-text-align-${textAlignSm || 'none'}`}
    >
      <Typography
        className='quote'
        {...quote}
      />
      {subQuote && (
        <Typography
          className='sub-quote'
          {...subQuote}
        />
      )}
      <Attribution
        {...attribution}
        textAlignSm={textAlignSm}
      />
    </QuoteContainer>
  );
};

export default QuoteAndAttribution;
